import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext';
import { IcCalendarCheck, IcRepeat, IcSave } from "../../Icons";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../layout/Header/Header";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

function MensualidadesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS         = process.env.REACT_APP_URL_LOGS;
  const URL_MENSUALIDADES = process.env.REACT_APP_URL_MENSUALIDADES;
  const URL_CLIENTES     = process.env.REACT_APP_URL_CLIENTES;

  const [cliente,         setCliente]         = useState([]);
  const [fecha_inicio,    setFechaInicio]     = useState("");
  const [frecuencia,      setFrecuencia]      = useState("");
  const [descripcion,     setDescripcion]     = useState("");
  const [observaciones,   setObservaciones]   = useState("");
  const [mes_aumento,     setMesAumento]      = useState("");
  const [importe_actual,  setImporteActual]   = useState("");
  const [selectedCliente, setSelectedCliente] = useState("");
  const [value,           setValue]           = useState('');
  const [validaBoton,     setValidaBoton]     = useState(true);

  const clear = () => {
    setCliente([]);
    setFechaInicio("");
    setDescripcion("");
    setObservaciones("");
    setImporteActual("");
    setFrecuencia('');
    setSelectedCliente("");
    setValidaBoton(true);
  };

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setCliente(allClientes);
      })
      .catch((err) => {});
  }, []);

  const saveMensualidad = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_MENSUALIDADES,
        {
          fecha_inicio,
          frecuencia,
          descripcion,
          observaciones,
          importe_actual,
          importe_anterior: 0,
          ultimo_aumento: fecha_inicio,
          mes_aumento,
          clientes: value._id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Crear Mensualidad',
            detalle: `${value._id}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const options = cliente.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      {user.usuarios_permisos ? (
        <div className="card container col-sm-9">

          {/* ── Page header ────────────────────────────────────────────── */}
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcCalendarCheck style={{ marginRight: 8, color: "#8b5cf6" }} />
                Nueva Mensualidad
              </h3>
              <p className="page-subtitle">Registra una mensualidad recurrente para un cliente</p>
            </div>
          </div>

          <Form onSubmit={saveMensualidad}>

            {/* ── Sección: Información de la Mensualidad ───────────────── */}
            <div className="form-section">
              <div className="form-section-header">
                <IcRepeat />
                <span className="form-section-title">Información de la Mensualidad</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Cliente</Label>
                      <Autocomplete
                        size="small"
                        value={value}
                        onChange={(event, selectedCliente) => {
                          setValue(selectedCliente);
                        }}
                        options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                        groupBy={(option) => option.firstLetter}
                        getOptionLabel={(option) => option.junta || ""}
                        renderInput={(params) => (
                          <TextField {...params} label="Selecciona" variant="outlined" />
                        )}
                        renderOption={(option) => (
                          <React.Fragment>{option.nombre_comercial}</React.Fragment>
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Frecuencia</Label>
                      <Input
                        type="select"
                        value={frecuencia}
                        required
                        onChange={(e) => setFrecuencia(e.target.value)}
                      >
                        <option value="0">Frecuencia</option>
                        <option value="Mensual">Mensual</option>
                        <option value="Anual">Anual</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Fecha Inicio</Label>
                      <Input
                        type="date"
                        value={fecha_inicio}
                        required
                        onChange={(e) => setFechaInicio(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Importe</Label>
                      <Input
                        type="number"
                        placeholder="0.00"
                        value={importe_actual}
                        onChange={(e) => setImporteActual(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={5}>
                    <FormGroup>
                      <Label>Descripción</Label>
                      <Input
                        type="text"
                        placeholder="Descripción"
                        value={descripcion}
                        onChange={(e) => setDescripcion(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Observaciones</Label>
                      <Input
                        type="text"
                        placeholder="Observaciones"
                        value={observaciones}
                        onChange={(e) => setObservaciones(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Mes del siguiente aumento</Label>
                      <Input
                        type="select"
                        value={mes_aumento}
                        onChange={(e) => setMesAumento(e.target.value)}
                      >
                        <option value="">Sin definir</option>
                        {["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                          "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
                        ].map((m) => <option key={m} value={m}>{m}</option>)}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>

            {/* ── Submit ──────────────────────────────────────────────── */}
            <div className="submit-bar">
              <Button type="submit" color="success" disabled={!validaBoton}>
                <IcSave style={{ marginRight: 6 }} />
                Registrar Mensualidad
              </Button>
            </div>

          </Form>
        </div>
      ) : undefined}
    </>
  );
}

export default MensualidadesCreate;
